import React from 'react';
import { Link } from 'react-router-dom';
import logo from '../assets/bleums-logo.png';
import FeaturedCarousel from '../components/FeaturedCarousel';
import { useHasProducts } from '../hooks/useHasProducts';

const Home: React.FC = () => {
  const hasProducts = useHasProducts();

  return (
    <div>
      {/* Hero */}
      <section className="bg-background-dark">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 py-20 grid md:grid-cols-2 gap-10 items-center">
          <div>
            <h1 className="font-serif text-4xl sm:text-5xl font-medium text-primary leading-tight">
              Handcrafted embroidery, vinyl, and more made just for you.
            </h1>
            <p className="mt-4 text-text-light">
              Personalized monograms, custom designs, and ready-made pieces — each
              stitched with care by Bleums Creations.
            </p>
            <div className="mt-6 flex gap-3">
              {/* No point sending anyone to an empty shop. */}
              {hasProducts && (
                <Link
                  to="/shop"
                  className="bg-primary text-white rounded px-5 py-3 text-sm font-medium hover:bg-primary-dark"
                >
                  Shop the collection
                </Link>
              )}
              <Link
                to="/custom-request"
                className={
                  hasProducts
                    ? 'border border-primary text-primary rounded px-5 py-3 text-sm font-medium hover:bg-primary/5'
                    : 'bg-primary text-white rounded px-5 py-3 text-sm font-medium hover:bg-primary-dark'
                }
              >
                Request a custom piece
              </Link>
            </div>
          </div>
          <div className="aspect-square bg-white rounded shadow-sm flex items-center justify-center p-10">
            <img
              src={logo}
              alt="Bleums Creations"
              className="max-h-full max-w-full object-contain"
            />
          </div>
        </div>
      </section>

      {/* Rolling gallery of past work. Hides itself when empty. */}
      <FeaturedCarousel />

      {/* Custom CTA */}
      <section className="bg-primary text-white">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 py-14 text-center">
          <h2 className="text-2xl font-semibold">Looking for something one-of-a-kind?</h2>
          <p className="mt-2 text-white/80">
            Share your idea and reference images. We'll send back a quote.
          </p>
          <Link
            to="/custom-request"
            className="inline-block mt-5 bg-white text-primary rounded px-5 py-3 text-sm font-medium hover:bg-background"
          >
            Start a custom order
          </Link>
        </div>
      </section>
    </div>
  );
};

export default Home;
